import { render } from "./addRestrictions.vue?vue&type=template&id=7247c924&scoped=true"
import script from "./addRestrictions.vue?vue&type=script&lang=js"
export * from "./addRestrictions.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./addRestrictions.vue?vue&type=style&index=1&id=7247c924&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7247c924"]])

export default __exports__